import { Transition, Disclosure } from '@headlessui/react'
import { ArrowCircleRightIcon } from '@heroicons/react/outline'
import Image from 'next/image';

export default function Faq() {
  return (
    <section className="relative bg-white bg-center overflow-hidden font-['Inter']">
      <div className="bg-transparent">
        <div className="relative pt-16 pb-12">
          <div className="container px-4 md:px-0 mx-auto max-w-3xl lg:max-w-5xl">
            <div className="relative flex flex-wrap justify-center -mx-4">
              <div className="w-full px-4 mb-12 md:mb-0 text-center">
                <h1
                  className="main-top-title mb-16">
                  Frequently Asked Questions<br />
                </h1>
                <div>
                  <div className="w-full px-10">
                    <div className="flex flex-col md:items-left items-center justify-center text-left">
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">What is the duration of the CKAN training course?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">The duration of the CKAN training course can vary depending on the program, ranging from a couple of days to several weeks. Our team can work with you to determine the best training plan to meet your needs and schedule.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">Are there any prerequisites for attending the CKAN training course?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">No, there are no strict prerequisites for attending the CKAN training course. However, our team will work with you to assess the level of the group and customize the program to ensure that it is tailored to your team&apos;s skill level and specific needs.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">Who are the trainers providing the CKAN training?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">Our trainers are experts in the field with real-world experience in implementing and working with CKAN and open data. They have extensive knowledge and expertise in CKAN and related technologies, as well as experience in training and supporting teams of all levels.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">Can the CKAN training course be customized to our specific needs?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">Absolutely! Our team understands that every organization has unique needs and requirements, which is why we provide customized training programs to fit your team&apos;s skill levels and needs. From beginner to advanced users, we provide comprehensive CKAN training that is tailored to your specific needs.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">How many people can attend the CKAN training course at once?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">
                                      When it comes to the number of people who can attend our CKAN training course, we believe that smaller groups lead to better learning outcomes. We generally recommend having groups of up to 25 people to ensure that each participant receives personalized attention and the best possible learning experience. If the group is large, we will work with you to determine the optimal group size and customize the training program accordingly. Our team of experienced trainers can adapt the content and pace of the course to meet the needs of both beginners and advanced users, ensuring that everyone benefits from the training.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
